module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "page-niveau page",
    attrs: {
      "id": "page-niveau"
    }
  }, [_c('div', {
    staticClass: "page__content"
  }, [_c('h1', [_vm._v("Ik wil lesgeven in het")]), _vm._v(" "), _c('div', {
    staticClass: "container list-select"
  }, [_vm._l((_vm.levels), function(level) {
    return _c('div', {
      staticClass: "list-select__item row",
      class: {
        'list-select__item--selected': level === _vm.currentLevel
      },
      on: {
        "click": function($event) {
          _vm.selectType(level)
        }
      }
    }, [_vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "col-10-sm list-select__item-text"
    }, [_vm._v("\n                    " + _vm._s(level) + "\n                ")])])
  }), _vm._v(" "), (_vm.currentLevel && _vm.currentLevel !== 'voortgezet onderwijs') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-2-sm"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-10-sm"
  }, [_c('p', [_vm._v("Mooi! Er zijn flinke tekorten in het " + _vm._s(_vm.currentLevel) + " en dit blijft waarschijnlijk de komende jaren zo. Je bent dus hartstikke hard nodig in het onderwijs en dit vergroot de kans dat je snel een baan vindt.")])])]) : _vm._e(), _vm._v(" "), (_vm.currentLevel) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-2-sm"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-10-sm list-select__title"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": _vm.nextHandler
    }
  }, [_vm._v("Volgende")])])]) : _vm._e()], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-2-sm list-select__item-marker-column"
  }, [_c('div', {
    staticClass: "list-select__item-marker"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38059604","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/page-niveau.vue
// module id = 138
// module chunks = 0